import React from "react";
import {connect, RootStateOrAny} from "react-redux";
import {ISetupState} from "../../../redux/reducers/Setup";
import IUser from "../../../model/interface/security/IUser";
import {IBaseViewProps} from "./ViewUnit";
import {Button, Col, Dropdown, Menu} from "antd";
import {Link} from "react-router-dom";
import {SettingOutlined} from "@ant-design/icons";
import IContentType from "../../../model/interface/dataStorage/IContentType";
import selectors from "../../../redux/selectors";
import UsersService from "../../../model/service/security/UsersService";
import LocaleText from "../settings/dictionary/LocaleText";

interface IState {

}

interface IProps extends IBaseViewProps {
    user: IUser,
    findContentTypeByUuid: (uuid: string) => IContentType,
}

class ViewEditButton extends React.Component<IProps, IState> {

    constructor(props: Readonly<IProps> | IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {
            view,
            user,
            showBaseSettings,
            findContentTypeByUuid
        } = this.props

        return UsersService.hasCredential(user, 'configuration') && !!view.id ? (
            <Col>
                <Dropdown trigger={["click"]} overlay={(
                    <Menu>
                        <Menu.Item key="1" onClick={showBaseSettings}>
                            <LocaleText code={'configuration.view.edit-button.settings'} fallback={'Změnit výchozí nastavení'}/>
                        </Menu.Item>
                        <Menu.Item key="2">
                            <Link to={"/app/configuration/views/" + view.id}>
                                <LocaleText code={'configuration.view.edit-button.edit'} fallback={'Upravit pohled'}/>
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="3">
                            <Link
                                to={"/app/configuration/content-types/" + findContentTypeByUuid(view.contentType).id}>
                                <LocaleText code={'configuration.view.edit-button.content-type'} fallback={'Upravit typ obsahu'}/>
                            </Link>
                        </Menu.Item>
                    </Menu>
                )}>
                    <Button
                        style={{verticalAlign: "middle"}}
                        icon={<SettingOutlined/>}
                        size={"small"}
                    />
                </Dropdown>
            </Col>
        ) : <></>
    }
}


const mapStateToProps = (state: RootStateOrAny) => {
    const {user} = state.setup as ISetupState
    return {
        findContentTypeByUuid: (uuid: string): IContentType => selectors.contentTypes.findOneBy(state, 'uuid', uuid),
        user
    }
}

export default connect(mapStateToProps)(ViewEditButton)